export { default } from './ArrowLongRight'
